import { DriverAuthenticationClient, Token } from '@frontend/authentication-v2';
import { DeviceClient } from '@frontend/device/api';
import { Device, DeviceBrand, DeviceType } from '@frontend/device/types';
import { useEffect, useMemo, useState } from 'react';

import { EmulatorType } from '../emulators/types';
import { IotDashboardProps } from './iot-dashboard.component';

interface ViewProps {
    token: Token | null;
    devices: Device[] | null;
    relevantDeviceInfo: EmulatorType[] | null;
}

const useIotDashboard = (props: IotDashboardProps): ViewProps => {
    const [token, setToken] = useState<Token | null>(null);
    const [devices, setDevices] = useState<Device[] | null>(null);

    useEffect(() => {
        DriverAuthenticationClient.provision({
            identifier: props.iot.identifier,
            type: props.iot.type,
            brand: props.iot.brand
        })
            .then(setToken)
            .catch(console.error);

        DeviceClient.fetchDevices({ account_id: props.iot.account_id, iot_id: props.iot.id })
            .then((response) => setDevices(response.results))
            .catch(console.error);
    }, [props.iot]);

    const relevantDeviceInfo: EmulatorType[] | null = useMemo(() => {
        if (!devices) return null;
        const info = [];
        if (devices.find((d) => d.type === DeviceType.CABINET && d.brand === DeviceBrand.ZHILAI)) {
            info.push(EmulatorType.ZHILAI_DRIVER);
        }
        if (devices.find((d) => d.type === DeviceType.QR_READER)) {
            info.push(EmulatorType.QR_READER);
        }
        if (devices.find((d) => d.type === DeviceType.KEYBOARD)) {
            info.push(EmulatorType.KEYBOARD);
        }
        return info;
    }, [devices]);

    return { token, devices, relevantDeviceInfo };
};

export default useIotDashboard;
